import { render } from "./NotFound.vue?vue&type=template&id=3058a3df&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=3058a3df&scoped=true&lang=scss"

import exportComponent from "D:\\htdocs\\cosmocoslab_live\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3058a3df"]])

export default __exports__